<template>
  <div class="role-user-list">
    <crm-panel :title="'产品线管理'">
      <div class="mt20 mb20 sub-tools">
        <div class="sub-handle">
          <el-form ref="form" :inline="true">
            <!-- 请输入产品线名称 -->
            <el-form-item label="">
              <el-input
                placeholder="请输入产品线名称"
                clearable
                @change="handleSearch({ pageNumber: 1 })"
                v-model.trim="info.name"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
            <!-- 产品线大类 -->
            <el-form-item label="">
              <el-select
                clearable
                v-model="info.typeCode"
                placeholder="产品线大类"
                @change="handleSearch({ pageNumber: 1 })"
              >
                <el-option
                  v-for="item in productLineTypeList.data"
                  :label="item.typeName"
                  :value="item.typeCode"
                  :key="item.typeCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 状态 -->
            <el-form-item label="">
              <el-select
                clearable
                v-model="info.status"
                placeholder="状态"
                @change="handleSearch({ pageNumber: 1 })"
              >
                <el-option
                  v-for="item in statusList"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table
        :data="productList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          label="产品线名称"
          align="center"
          width="160"
          show-overflow-tooltip
          prop="name"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleViewClick(scope.row)">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品线编号"
          align="center"
          width="300"
          prop="code"
        >
        </el-table-column>
        <el-table-column prop="typeName" align="center" label="归属产品大类">
        </el-table-column>
        <el-table-column prop="status" align="center" label="状态">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.status === 0 && scope.row.bfmStatus === 0
                  ? '已启用'
                  : '已停用'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="gmtModifiedStr" align="center" label="更新时间">
        </el-table-column>
        <el-table-column
          align="center"
          width="150"
          label="操作"
          v-if="
            productManageAuth &&
              productManageAuth.productLineEnabled.toggleStatus &&
              productManageAuth.productLineDisabled.toggleStatus
          "
        >
          <template slot-scope="scope">
            <el-button
              @click="handleChangeSataus(scope)"
              type="text"
              size="small"
              >{{
                scope.row.status === 0 && scope.row.bfmStatus === 0
                  ? '停用'
                  : '启用'
              }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="productList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 详情弹窗 -->
    <we-product-details
      v-show="productDetailShow"
      v-bind="viewPanel"
      @closeProductDetail="closeProductDetail"
      @saveEditProduct="saveEditProduct"
    >
    </we-product-details>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import service from '~api/backstage';
import WeProductDetails from '~component/business/product/productDetails';

export default {
  components: {
    crmPanel,
    crmButton,
    // authRoleUser,
    WeProductDetails,
  },
  data() {
    this.statusList = [
      {
        value: '0',
        label: '已启用',
      },
      {
        value: '1',
        label: '已停用',
      },
    ];
    return {
      info: {
        name: '',
        typeCode: '',
        status: '',
      },
      loading: false,
      productDetailShow: false,
      page: {
        pageSize: 10,
        pageNumber: 1,
      },
      // 产品线大类下拉列表
      productLineTypeList: [],
      // 查看面板
      viewPanel: {
        id: '',
        authEdit: false,
        authDelete: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      productList: 'backstage/productList',
      productManageAuth: 'authority/productManageAuth',
    }),
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getProductList: 'backstage/getProductList',
    }),
    // 查看详情
    handleViewClick(row) {
      if (!this.productManageAuth.productLineDetail.toggleStatus) {
        this.$message({
          message: '暂无查看详情权限！',
          type: 'error',
        });
        return;
      }
      this.productDetailShow = true;
      this.viewPanel = Object.assign(this.viewPanel, {
        id: row.id,
      });
    },
    init() {
      // 产品线大类下拉
      service.queryProductLineType().then((res) => {
        this.productLineTypeList = res.data;
      });

      this.getProductList({
        ...this.page,
        ...this.info,
      });
    },
    // 新建
    addDialog() {
      this.$refs.dialogAuthRole.isAuthDialogVisible = true;
      this.$refs.dialogAuthRole.info = this.info;
    },
    handleSearch(page) {
      if (page) this.page.pageNumber = page?.pageNumber;
      this.getProductList({
        ...this.page,
        ...this.info,
        pageNumber: (page && page.pageNumber) || this.page.pageNumber,
      });
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNumber = 1;
      this.handleSearch();
    },
    handlePageChange(index) {
      this.page.pageNumber = index;
      this.handleSearch();
    },
    handleRefresh() {
      this.handleSearch();
    },
    handleDelete(scope) {
      this.$confirm(`您确定要删除用户${scope.row.userName}？`).then(() => {
        service
          .apiDelRoleUser({
            roleId: this.info.roleId,
            userId: scope.row.userId,
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除用户成功',
            });
            this.handleSearch();
          });
      });
    },
    handleChangeSataus(scope) {
      const params = {
        id: scope.row.id,
        status: scope.row.status,
      };
      // 启用状态 需要停用 提示框
      if (scope.row.status === 0 && scope.row.bfmStatus === 0) {
        this.$confirm(
          '停用后，该产品线将不可再被新的商机、合同关联，是否继续？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(() => {
            service.disabledProductLine(params).then((res) => {
              this.handleSearch();
            });
          })
          .catch(() => {});
      } else {
        // 停用状态 需要启用
        service.enableProductLine(params).then((res) => {
          this.handleSearch();
        });
      }
    },
    saveEditProduct() {
      this.handleSearch();
    },
    closeProductDetail() {
      this.productDetailShow = false;
      this.viewPanel.id = '';
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
@import '~@/styles/const.less';
.sub-tools {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.sub-handle {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  .mb20 {
    margin-bottom: 20px;
  }
  .crm-button {
    margin-right: 20px;
  }
}

.role-user-list {
  display: flex;
  flex: 1;
  width: 100%;
  h1 {
    max-width: 50%;
    color: #7a84b7;
  }
  .dialog-body {
    padding-right: 40px;
  }
}
</style>
